import React from 'react';
import apiClient from '../utils/api';
import './AdminBanner.css';

function AdminBanner() {
  const adminToken = localStorage.getItem('admin_token');
  const adminUser = localStorage.getItem('admin_user');
  
  if (!adminToken || !adminUser) {
    return null;
  }

  const admin = JSON.parse(adminUser);

  const handleReturnToAdmin = () => {
    // Restore admin token
    apiClient.setToken(adminToken);
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    
    // Redirect to admin panel
    window.location.href = '/admin';
  };

  return (
    <div className="admin-banner">
      <div className="admin-banner-content">
        <div className="admin-banner-icon">🔑</div>
        <div className="admin-banner-text">
          <strong>Admin-Modus:</strong> Du bist als Admin ({admin.email}) im User-Account eingeloggt
        </div>
        <button onClick={handleReturnToAdmin} className="btn-return-admin">
          ← Zurück zum Admin-Panel
        </button>
      </div>
    </div>
  );
}

export default AdminBanner;
